// extracted by mini-css-extract-plugin
export default {"section":"styles_section__z1s99","icon":"styles_icon__e-ymK","heading":"styles_heading__DeFt7","para":"styles_para__O2pDM","email":"styles_email__FDQG+"};